export default "__VITE_ASSET__DuwcuQty__"